(function (jQuery, Drupal) {
  'use strict';
  var once = true;
  Drupal.behaviors.media_library = {
    attach: function (context, settings) {
      if (once) {
        once = false;
        var $page = jQuery('body.page-node-type-page-media-library');
        if ($page.length > 0) {
          var $view = $page.find('.view.view-vpm-media-library');
          var $menu = $view.find('.view-filters .form-item-field-media-library-tag');
          var urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('field_media_library_tag')) {
            var media_library_tag = urlParams.get('field_media_library_tag');
            $menu.find('div > ul > li').each(function (index, element) {
              var $element = jQuery(element);
              $element.find('> ul > li').each(function (index, element) {
                var $subelement = jQuery(element);
                var active = false;
                $subelement.find('a').each(function (index, element) {
                  var $subsubelement = jQuery(element);
                  if ($subsubelement.attr('name') == 'field_media_library_tag[' + media_library_tag + ']') {
                    active = true;
                  }
                });
                if (active) {
                  $subelement.find('> ul').toggleClass('active');
                }
              });
            });
          }
        }
      }
    }
  }
})(jQuery, Drupal);
